<script setup lang="ts">
import { computed } from "vue";

import { useArticleFont } from "@/common/composables/use-article-font.composable";
import { mergeInflections } from "@/components/article/dictsys/inflectionSchemes/german/merge-inflections";
import type { DictsysInflectionSchemeContent } from "@/types/article-formats/dictsys";

interface Props {
  content: DictsysInflectionSchemeContent[] | string;
}

const props = defineProps<Props>();

const { articleFontClass } = useArticleFont();

const content = computed<string>(() => {
  if (typeof props.content === "string") {
    return props.content;
  }

  return `${props.content[0].prefix} ${mergeInflections(props.content)}`;
});
</script>

<template>
  <span class="inflection-scheme-cell" :class="articleFontClass">{{ content }}</span>
</template>
